import styled from 'styled-components';

import type { Color, Size as ThemeSize } from '../../../../style/types/theme';
import { Size } from '../types';

interface WrapperProps {
  $isPrimary: boolean;
  $size?: Size;
  $disabled?: boolean;
  onClick?: () => void;
}

const getSize = (themeSize: ThemeSize, size?: Size) => {
  return size === Size.SMALL ? themeSize.units(3) : themeSize.units(4);
};

const getHoverColor = (themeColor: Color, isPrimary: boolean) => {
  return isPrimary
    ? themeColor.content.reversed.hover()
    : themeColor.content.secondary.hover();
};

export const Wrapper = styled.div<WrapperProps>(
  ({
    theme: { size, color, font, transition },
    $isPrimary,
    $size,
    onClick,
    $disabled,
  }) => ({
    cursor: onClick ? 'pointer' : 'default',
    minWidth: getSize(size, $size),
    minHeight: getSize(size, $size),
    width: getSize(size, $size),
    height: getSize(size, $size),
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: $isPrimary
      ? color.background.reversed.default()
      : color.background.quaternary.default(),
    color: $isPrimary
      ? color.content.reversed.default()
      : color.content.secondary.default(),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: size.units(1.5),
    fontFamily: font.family,
    transition: transition.standard('background-color', 'color'),
    opacity: $disabled ? 0.5 : undefined,

    ':hover': {
      backgroundColor:
        $isPrimary && onClick ? color.background.accent.hover() : undefined,
      color: onClick ? getHoverColor(color, $isPrimary) : undefined,
    },
  }),
);
